if (!customElements.get("customer-reviews-slider")) {
  class CustomerReviewsSlider extends HTMLElement {
    connectedCallback() {
      if (this.swiper) return;

      this.initializeSlider();
    }

    initializeSlider(attempt = 0) {
      if (this.swiper) return;

      const slider = this.querySelector(
        "[data-customer-reviews-swiper]"
      );

      if (!slider) return;

      if (typeof window.Swiper !== "function") {
        if (attempt >= 40) {
          console.warn(
            "Customer reviews slider: Swiper is not available."
          );
          return;
        }

        window.setTimeout(() => {
          this.initializeSlider(attempt + 1);
        }, 100);

        return;
      }

      const previousButton = this.querySelector(
        "[data-customer-reviews-prev]"
      );

      const nextButton = this.querySelector(
        "[data-customer-reviews-next]"
      );

      const pagination = this.querySelector(
        "[data-customer-reviews-pagination]"
      );

      const slideCount = slider.querySelectorAll(
        ".swiper-slide"
      ).length;

      const slidesDesktop =
        Number(this.dataset.slidesDesktop) || 3.2;

      const slidesTablet =
        Number(this.dataset.slidesTablet) || 2.2;

      const slidesMobile =
        Number(this.dataset.slidesMobile) || 1.1;

      const gapDesktop =
        Number(this.dataset.gapDesktop) || 18;

      const gapMobile =
        Number(this.dataset.gapMobile) || 12;

      const sliderSpeed =
        Number(this.dataset.sliderSpeed) || 500;

      const enableLoop =
        this.dataset.enableLoop === "true";

      const enableDrag =
        this.dataset.enableDrag === "true";

      const autoRotate =
        this.dataset.autoRotate === "true";

      const options = {
        slidesPerView: slidesMobile,
        slidesPerGroup: 1,
        spaceBetween: gapMobile,
        speed: sliderSpeed,

        loop:
          enableLoop &&
          slideCount > Math.ceil(slidesDesktop),

        watchOverflow: true,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        grabCursor: enableDrag,
        allowTouchMove: enableDrag,
        simulateTouch: enableDrag,

        mousewheel: {
          forceToAxis: true
        },

        breakpoints: {
          750: {
            slidesPerView: slidesTablet,
            spaceBetween: gapDesktop
          },

          990: {
            slidesPerView: slidesDesktop,
            spaceBetween: gapDesktop
          }
        }
      };

      if (previousButton && nextButton) {
        options.navigation = {
          prevEl: previousButton,
          nextEl: nextButton
        };
      }

      if (pagination) {
        options.pagination = {
          el: pagination,
          clickable: true
        };
      }

      if (autoRotate && slideCount > 1) {
        options.autoplay = {
          delay:
            Number(this.dataset.autoRotateDelay) ||
            5000,
          disableOnInteraction: false
        };
      }

      this.swiper = new window.Swiper(
        slider,
        options
      );

      if (
        autoRotate &&
        this.dataset.pauseOnHover === "true"
      ) {
        this.handleMouseEnter = () => {
          this.swiper?.autoplay?.pause();
        };

        this.handleMouseLeave = () => {
          this.swiper?.autoplay?.resume();
        };

        this.addEventListener(
          "mouseenter",
          this.handleMouseEnter
        );

        this.addEventListener(
          "mouseleave",
          this.handleMouseLeave
        );
      }
    }

    disconnectedCallback() {
      if (this.handleMouseEnter) {
        this.removeEventListener(
          "mouseenter",
          this.handleMouseEnter
        );
      }

      if (this.handleMouseLeave) {
        this.removeEventListener(
          "mouseleave",
          this.handleMouseLeave
        );
      }

      if (this.swiper && !this.swiper.destroyed) {
        this.swiper.destroy(true, true);
      }

      this.swiper = null;
    }
  }

  customElements.define(
    "customer-reviews-slider",
    CustomerReviewsSlider
  );
}